import moment from 'moment'

const monthly = num => moment(num+'','YYYYMM').format('MMM YYYY')

export const sheetToOption = sheet => ({
  label : monthly(sheet?.month) +' - '+ sheet?.name,
  value : sheet?.id,
})
